import { render, staticRenderFns } from "./gdpr.vue?vue&type=template&id=ecaba26e"
import script from "./gdpr.vue?vue&type=script&lang=js"
export * from "./gdpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports